import { render, staticRenderFns } from "./SecurityOrderAdd.vue?vue&type=template&id=0fbc0f7b&scoped=true"
import script from "./SecurityOrderAdd.vue?vue&type=script&lang=js"
export * from "./SecurityOrderAdd.vue?vue&type=script&lang=js"
import style0 from "./SecurityOrderAdd.vue?vue&type=style&index=0&id=0fbc0f7b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbc0f7b",
  null
  
)

export default component.exports